import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { useProductCenterApi } from 'api';
import { countryInfosECMQuery } from 'api/queries/ConfigurationQueries';
import { mapSupportedCountryCodeToIdLabelCountry } from 'api/responses/models/Configuration/SupportedCountryCodeDto';

import { CountryInput, CountryInputProps } from './CountryInput';

export const ECMCountryInput = <
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
	props: CountryInputProps<TFieldValues, TName>
) => {
	const { api } = useProductCenterApi();
	const { data } = useQuery(countryInfosECMQuery(api));
	const options = useMemo(
		() =>
			data
				?.filter(({ countryName }) => countryName !== 'Null') // TODO: temporary fix for backend issue - ECM
				.map(mapSupportedCountryCodeToIdLabelCountry) || [],
		[data?.length]
	);

	return <CountryInput {...props} options={options} withFlag />;
};
